var n = function(r) {
  if (r)
    return "current" in r ? n(r.current) : r;
};
export {
  n as _
};
